import React, { useState } from "react";import { DRAWER_BACKGROUND } from "../../../constants/styles";

export default function AssetDetailsDrawer({ open, setOpen, onSelect }) {
	const [query, setQuery] = useState("");

	   const assets = [
	     {
	       name: "TV Monitor - Meeting Room",
	       sweep: "qh6mtg3gstcuan328kznn84ha",
	       rotation: 187
	     },
	     {
	       name: "Wall Display - Reception",
	       sweep: "abcd1234",
	       rotation: 90
	     },
	     {
	       name: "Screen - Breakout Area",
	       sweep: "xyz5678",
	       rotation: 45
	     }
	   ];

	const filtered =
	  query.trim().length === 0
	    ? []
	    : assets.filter(function (a) {
	        return a.name.toLowerCase().includes(query.toLowerCase());
	      });

	   return (
	     <div style={{
	       position: "fixed",
	       top: "80px",
	       right: open ? "20px" : "-320px",
	       width: "300px",
	       background: DRAWER_BACKGROUND,
	       backdropFilter: "blur(10px)",
	       borderRadius: "14px",
	       padding: "16px",
	       boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
	       transition: "all 0.3s ease",
	       zIndex: 500,
	       color: "#fff"
	     }}>

	       <input
	         placeholder="Search assets..."
	         value={query}
	         onChange={(e) => setQuery(e.target.value)}
	         style={{
	           width: "100%",
	           padding: "10px",
	           borderRadius: "8px",
	           border: "none",
	           marginBottom: "12px",
	           background: "rgba(255,255,255,0.08)",
	           color: "#fff"
	         }}
	       />

	       {filtered.map(function (asset, i) {
	         return (
	           <div
	             key={i}
	             onClick={() => {
	               onSelect(asset);
	               setOpen(false);
	             }}
	             style={{
	               padding: "10px",
	               borderRadius: "8px",
	               marginBottom: "6px",
	               cursor: "pointer",
	               background: "rgba(255,255,255,0.05)"
	             }}
	           >
	             {asset.name}
	           </div>
	         );
	       })}

	     </div>
	   );
}